export default "__VITE_ASSET__929bf61a__"